<div class="file-preview-dialog">
  <!-- Header -->
  <!-- <div class="dialog-header" mat-dialog-title>
    <div class="file-info">
      <mat-icon class="file-icon">{{ getFileIcon() }}</mat-icon>
      <div class="file-details">
        <h3 class="filename" [title]="data.filename">{{ data.filename }}</h3>
        <p class="file-meta">{{ formatFileSize(data.fileSize) }} • {{ data.mimeType }}</p>
      </div>
    </div>
    <div class="header-actions">
      <button mat-icon-button (click)="onDownload()" matTooltip="Download">
        <mat-icon>download</mat-icon>
      </button>
      <button mat-icon-button (click)="onClose()" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div> -->

  <!-- Content -->
  <div class="dialog-content" mat-dialog-content>
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading preview...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error" class="error-container">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <p class="error-message">{{ errorMessage }}</p>
      <button mat-raised-button color="primary" (click)="onDownload()">
        <mat-icon>download</mat-icon>
        Download File
      </button>
    </div>

    <!-- Image Preview -->
    <div *ngIf="!error && data.isImage" class="image-container">
      <img 
        [src]="imageUrl" 
        [alt]="data.filename"
        (load)="onImageLoad()"
        (error)="onImageError()"
        class="preview-image"
      />
    </div>

    <!-- Office Documents Preview (Word, Excel & PowerPoint - use Microsoft Viewer) -->
    <div *ngIf="!loading && !error && !data.isImage && isOfficeDocument()" class="document-container">
      <!-- Microsoft Viewer Loading Overlay -->
      <div *ngIf="microsoftViewerLoading" class="microsoft-viewer-loading">
        <div class="loading-content">
          <mat-spinner diameter="60"></mat-spinner>
          <h3>Loading Document Preview</h3>
          <p>Microsoft Office Online is processing your {{ getDocumentType() }} document...</p>
          <!-- <p class="loading-time">Loading time: {{ loadingTime }}s</p> -->
          
          <!-- Show different messages based on loading time -->
          <!-- <div class="loading-tips" *ngIf="loadingTime < 20">
            <small>💡 Large documents may take 30-60 seconds to load</small>
          </div> -->
          <div class="loading-tips warning" *ngIf="loadingTime >= 20 && loadingTime < 40">
            <small>⏳ Taking longer than usual. Please wait...</small>
          </div>
          <div class="loading-tips error" *ngIf="loadingTime >= 40">
            <small>🚨 Loading is taking unusually long. There may be a network issue.</small>
          </div>
          
          <!-- Manual stop button for long loads -->
          <div class="loading-actions" *ngIf="loadingTime >= 30">
            <button mat-stroked-button (click)="forceStopLoading()" class="stop-loading-btn">
              <mat-icon>stop</mat-icon>
              Stop Loading & Download
            </button>
          </div>
        </div>
      </div>
      
      <iframe 
        [src]="microsoftViewerUrl"
        class="office-viewer"
        [class.hidden-iframe]="microsoftViewerLoading"
        (load)="onMicrosoftViewerLoaded()"
        (error)="onMicrosoftViewerError($event)"
        frameborder="0">
      </iframe>
     
    </div>

    <!-- PDF Documents Preview (use PDF.js) -->
    <div *ngIf="!loading && !error && !data.isImage && data.isPdf" class="document-container">
      <!-- PDF.js Loading Overlay -->
      <div *ngIf="pdfLoading" class="pdf-loading-overlay">
        <div class="loading-content">
          <mat-spinner diameter="50"></mat-spinner>
          <h3>Loading PDF Document</h3>
          <p>Preparing PDF viewer...</p>
          <!-- <p class="loading-time" *ngIf="pdfLoadingTime > 0">Loading time: {{ pdfLoadingTime }}s</p> -->
        </div>
      </div>

      <pdf-viewer 
        *ngIf="!documentError"
        [src]="data.fileUrl"
        [render-text]="true"
        [original-size]="false"
        [fit-to-page]="true"
        [show-all]="true"
        [autoresize]="true"
        [zoom-scale]="'page-width'"
        class="pdf-viewer"
        (after-load-complete)="onPdfLoaded($event)"
        (error)="onPdfError($event)"
        (page-rendered)="onPdfPageRendered($event)">
      </pdf-viewer>
     
      <!-- PDF Error Fallback -->
      <div *ngIf="documentError" class="document-fallback">
        <mat-icon class="fallback-icon">{{ getFileIcon() }}</mat-icon>
        <p class="fallback-message">Unable to display PDF document</p>
        <p class="fallback-subtitle">PDF may be corrupted or not supported</p>
        <div class="fallback-actions">
          <button mat-raised-button color="primary" (click)="onDownload()">
            <mat-icon>download</mat-icon>
            Download PDF
          </button>
        </div>
      </div>
    </div>

    <!-- Other Documents Preview (non-PDF formats - use Google Docs Viewer) -->
    <div *ngIf="!loading && !error && !data.isImage && !isOfficeDocument() && !data.isPdf" class="document-container">
      <!-- Use ngx-doc-viewer for other document types -->
      <ngx-doc-viewer 
        *ngIf="!documentError"
        [url]="data.fileUrl"
        [viewerUrl]="'https://docs.google.com/viewer'"
        [config]="{ disablePrint: false, disableDownload: true, disableOpenInDrive: true }"
        class="doc-viewer"
        (loaded)="onDocumentLoaded($event)"
        (error)="onDocumentError($event)">
      </ngx-doc-viewer>
     
      <!-- Document Error Fallback -->
      <div *ngIf="documentError" class="document-fallback">
        <mat-icon class="fallback-icon">{{ getFileIcon() }}</mat-icon>
        <p class="fallback-message">Unable to display document preview</p>
        <p class="fallback-subtitle">This document may not be supported for inline viewing</p>
        <div class="fallback-actions">
          <button mat-raised-button color="primary" (click)="onDownload()">
            <mat-icon>download</mat-icon>
            Download Document
          </button>
        </div>
      </div>
    </div>




  </div>

     <!-- Footer Actions -->
   <div class="dialog-actions" mat-dialog-actions>
     <button mat-raised-button mat-dialog-close (click)="onCancel()">Close</button>
     <button mat-button autofocus (click)="onDownload()">
       <mat-icon>download</mat-icon>
       Download
     </button>
   </div>
</div>
